const host = window.location?.host;
const isLLE = host?.includes('sandbox') || host?.includes('qa02') || host?.includes('preprod');
const braintreeAuthorizationToken = isLLE
  ? 'sandbox_tvsr3x3t_mkcfj7wcgxrrwv7v'
  : 'production_38kzz3xm_g7qpdhwpcnyx6hj8';
export default braintreeAuthorizationToken;
